<template>
  <div class="container" v-loading="alignmentLoading" :element-loading-text="loadingText">
    <!--    顶部按钮-->
    <div class="button-container">
      <AlignmentButton @deleteRepeatSent="deleteRepeatSent" @beginAlignment="beginAlignment" @exchangeSent="exchangeSent"
        @seekShow="seekShow" @onRedo="onRedo" @onUndo="onUndo" @onSplit="onSplit" @onMerge="onMerge"
        @addPopupShow="addPopupShow" @deleteAllSent="deleteAllSent" @toAddMemory="toAddMemory" @toggleBox="toggleBox"
        @handleDownload="handleDownload" />
    </div>
    <div class="hide" v-show="isShow || isAddMemoryShow"></div>
    <!--    未登录-->
    <div class="not-logged-in" v-show="!fileList || !fileList.length">
      <HomePage type="home" @setTargetLang="setTargetLang" @setSourceLang="setSourceLang">
      </HomePage>
    </div>
    <!--    上传文件后显示表格-->
    <div class="logged-in" v-show="fileList && fileList.length">
      <div class="table-container">
        <el-table ref="multipleTable" id="multipleTable" :data="tableData"
          :header-cell-style="{ background: '#F7F8FA', color: '#656B74', fontWeight: '400', padding: '8px' }"
          tooltip-effect="dark" :cell-style="setCellStyle" style="width:100%" height="100%" border
          @selection-change="handleSelectionChange" v-loading="loading" row-key="id" :resizable="false"
          :highlight-current-row="true" :row-class-name="tableRowClassName">
          <el-table-column :resizable="false" type="selection" align="center" width="60">
          </el-table-column>
          <el-table-column :resizable="false" type="index" label="序号" align="center" class-name="table-index"
            width="80"></el-table-column>
          <el-table-column :resizable="false" class-name="el-table_1_column_3" prop="sourceSent" :label="sourceSent">
            <template slot="header" slot-scope="scope">
              <div class="header-cell">
                <HomePage type="editor" srcDoc="source" @setSourceLang="setSourceLang" @setTargetLang="setTargetLang" />
                <!-- 源语言-->
                <!-- v-if="!isdisableStartAlignment" -->
                <el-select :disabled="isdisableStartAlignment" size="small" @change="getLangeObjectLeft(sourceLeft)"
                  v-model="sourceLeft" placeholder="源语言">
                  <el-option v-for="(item, index) in LangList" :key="item.sourceLang" :label="item.sourceLangName"
                    :value="item.sourceLang" :disabled="item.status === 0 || item.sourceLangName === sourceRight">
                  </el-option>
                </el-select>
              </div>
            </template>
            <template slot-scope="scope">
              <div class="edit" contenteditable="true" type="source" :sId="scope.row.id" @focus="changeVerify($event)"
                @blur="updateSent(scope.row, $event.target, 0)" @click="getCursorPosition($event, scope.row);"
                @keydown="setLimitLength($event)" @input="setMaxlength($event)" v-html="scope.row.sourceSent"
                @mouseup="selectOn">
              </div>
            </template>
          </el-table-column>
          <el-table-column :resizable="false" class-name="el-table_1_column_4" prop="targetSent" :label="targetSent">
            <template slot="header" slot-scope="scope">
              <div class="header-cell" :class="fileNumber === 1 ? 'float-right' : ''">
                <HomePage v-show="fileNumber === 2" type="editor" @setSourceLang="setSourceLang"
                  @setTargetLang="setTargetLang" srcDoc="target" />
                <!-- 目标语言 -->
                <!-- v-if="!isdisableStartAlignment" -->
                <el-select :disabled="isdisableStartAlignment" size="small" @change="getLangeObjectRight(sourceRight)"
                  no-data-text="请先选择源语言" v-model="sourceRight" placeholder="目标语言">
                  <el-option v-for="(item, index) in LangList2" :key="item.targetLang" :label="item.targetLangName"
                    :value="item.targetLang" :disabled="item.status === 0">
                  </el-option>
                </el-select>
              </div>
            </template>
            <template slot-scope="scope">
              <div class="edit" contenteditable="true" type="target" :sId="scope.row.id" @focus="changeVerify($event)"
                @blur="updateSent(scope.row, $event.target, 1)" @click="getCursorPosition($event, scope.row);"
                @keydown="setLimitLength($event)" @input="setMaxlength($event)" v-html="scope.row.targetSent"
                @mouseup="selectOn">
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- <div class="aling-footer" :class="{'fileList':isSent}"> -->
      <!-- 分页器 -->
      <Pagination layout="sizes, prev, pager, next" :page.sync="currentPage" v-if="isSent" :limit.sync="currentRow"
        :total="totalRows" :pageSizes="[15, 30, 60, 80]" @pagination="handlePagination" />
      <!-- <div class="alignRecords" @click="handleralignRecords" v-if="isSent">
        对齐记录>
      </div> -->
      <!--<template v-else>
          <div class="suffix-tips">
            <div class="tips-text">
              格式支持
            </div>
            <el-tooltip popper-class="editor-tool" effect="dark"
                        content="文件大小不超过20M，支持（docx、doc、txt、pdf、xlsx、xls、pptx、ppt、rtf、html、htm、xlf、odt、pot）格式文件"
                        placement="bottom-start">
              <img class="tips" :src="require('@/assets/imgs/alignment-icons/tips.png')" alt="">
            </el-tooltip>
          </div>
          
        </template> -->
      <!-- </div> -->
    </div>

    <Operation :isShow="isShow" @popupConfirm="popupConfirm" @popupCancel="popupCancel" :checkTxt="checkTxt"
      :isDel="isDel" :downloadBoxTit="downloadBoxTit" :downloadBoxText="downloadBoxText" :deleteType="deleteType"
      @closePopup="closePopup" />
    <Seek v-show="isSeekBox" :seekTxt="seekTxt" :seekTxt2="seekTxt2" :seekNum="seekNum" :seekNum2="seekNum2"
      @findNext="findNext" @findPrevious="findPrevious" @seekChange="seekChange" @onReplace="onReplace"
      @replaceChange="replaceChange" @onSeekTxt="onSeekTxt" @onSeekTxt2="onSeekTxt2" @onClose="seekShow" />
    <AddMemory :saveMemoryType="saveMemoryType" @memoryApi="memoryApi" @cancelAddMemory="cancelAddMemory" ref="addmemory"
      :isAddMemoryShow="isAddMemoryShow" />
    <unSaveDialog :visible="unSaveDialogVisible" @handleClose="handleClose" @handleConfirm="handleConfirm"></unSaveDialog>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination';
import Seek from "./components/seek";
import Operation from "./components/operation";
import AlignmentButton from "./components/alignment-button"
import HomePage from "./components/home-page";
import unSaveDialog from './components/unSaveDialog.vue';
import AddMemory from "./components/add-memory";
import Sortable from 'sortablejs';
import { mapState, mapActions, mapMutations } from "vuex";
import bilingualAlignmentAjax from "@/services/bilingualAlignment"
// import { getCookie } from '@/utils';
export default {
  name: "alignmentEditor",
  components: {
    Seek,
    Operation,
    AlignmentButton,
    HomePage,
    AddMemory,
    Pagination,
    unSaveDialog,
  },
  beforeRouteEnter(to, from, next) {
    next(async (vm) => {
      if (to.name === 'bilingualAlignment') {
        // 只要是进入home 统一将isdisableStartAlignment 存储为false
        sessionStorage.setItem('isdisableStartAlignment', JSON.stringify(false))
        // 不论是详情进入,还是首页进入 都需要从本地获取isdisableStartAlignment 
        vm.isdisableStartAlignment = JSON.parse(sessionStorage.getItem('isdisableStartAlignment')) || false
      }
      if (from.name === 'alignRecordsDetail' && to.name === 'bilingualAlignment') {
        sessionStorage.setItem('isdisableStartAlignment', JSON.stringify(true))
        sessionStorage.setItem('myRadio', 2)
        sessionStorage.setItem('isSent', null)
        vm.saveFileList(null)
        vm.changeFileNumber(2)
        vm.SET_IS_SENT()
        sessionStorage.removeItem("myFileList")
        sessionStorage.removeItem("sourceLang")
        sessionStorage.removeItem("targetLang")
        sessionStorage.removeItem("aligmentqueryInfo")
      }
    })
  },
  data() {
    return {
      cellType: 1,//拆分原文或译文
      currentCell: null,//当前点击单元格
      saveMemoryType: 0,//保存记忆库状态
      downloadBoxText: '',//删除条目文本
      deleteType: 1, //1为删除所选,2为删除全部
      tableData: [],//表格数据源
      multipleSelection: [], // 存储选中的数组
      isShow: false,//弹窗显示与隐藏开关
      downloadBoxTit: '',//弹窗标题
      topText: '',//添加原文
      botText: '',//添加译文
      isDel: false,//弹窗确认
      totalRows: 0, // 分页数据总数
      loading: false,//加载中
      sentCount: '',
      sourceSent: '',//原文
      targetSent: '',//译文
      updateText: '',//验证是否修改
      checkTxt: '双语对齐',
      sortable: null,//拖拽表格行
      isSeekBox: null,//查找替换
      seekTxt: "",
      seekTxt2: "",
      seekNum: 0,
      seekNum2: 0,
      currentRow: 15,//当前条数
      currentPage: 1,//当前页
      isAddMemoryShow: false,//显示保存术语库
      sourceLeft: "",//源语言
      sourceRight: "",//目标语言
      sourceLang: "",
      targetLang: "",
      LangList: [],//源语言数据源
      LangList2: [],//目标语言数据源
      prohibitClick: false,
      alignmentLoading: false,// loading 状态
      loadingText: "拼命加载中",
      groupId: null,// 批次ID
      pollingInter: null,//定时器
      userLastBatchID: null,// 批次ID
      // batchName: "", // 双语对齐文件名字
      // fileStatus: null,//批次状态 -1.删除 0.禁用 1.启用
      pollingNum: 0,// 轮询次数
      fileArr: [],//上传文件列表
      queryInfo: {},//查询数据条件
      tableRowIndex: 0,//
      upMerge:false, //能否合并
      isdisableStartAlignment: false, // 是否禁用开始对齐以及重新上传
      // isInitAlign: false,             // 路由跳转后是否初始化当前组件data
      introduce: [
        {
          imgSrc: require("@/assets/imgs/alignment-icons/home-page1.png"),
          title: "全面",
          present: "丰富格式与多语种支持",
        },
        {
          imgSrc: require("@/assets/imgs/alignment-icons/home-page3.png"),
          title: "迅捷",
          present: "一键去重筛选，快速定位",
        },
        {
          imgSrc: require("@/assets/imgs/alignment-icons/home-page2.png"),
          title: "智能",
          present: "智能算法高效对齐",
        },
        {
          imgSrc: require("@/assets/imgs/alignment-icons/home-page4.png"),
          title: "高效",
          present: "语料积累提高翻译效率",
        },
      ],
      unSaveDialogVisible:false,
      lastBatchInfo:{},
    }
  },
  watch: {
    fileList: {
      handler(data) {
        if (!data && this.userInfo && Object.keys(this.userInfo).length) {
          Object.assign(this.$data, this.$options.data.call(this))
          this.tableData = []
        } else {
          this.getLangList(1)
        }
      },
      deep: true,
      immediate: true
    },

    "$store.getters.sourceLang": {
      handler(data) {
        if (data) {
          console.log('@$$');
          setTimeout(() => {
            if (this.fileList && this.fileList.length) {
              this.sourceLeft = data
              this.getLangeObjectLeft(data)
            }
          }, 500)
        }
      },
      deep:true,
      immediate: true
    },
    "$store.getters.targetLang": {
      handler(data) {
        if (data) {
          setTimeout(() => {
            if (this.fileList && this.fileList.length) {
              this.sourceRight = data
              this.getLangeObjectRight(data)
            }
          }, 1000)
        }
      },
      deep:true,
      immediate: true
    },
  },
  computed: {
    ...mapState({
      fileList: state => state.alignment.fileList,
      userInfo: state => state.layout.userInfo,
      fileNumber: state => state.alignment.fileNumber,
      isSent: state => state.alignment.isSent,
    })
  },
  beforeDestroy() {
    clearTimeout(this.pollingInter);
    this.saveFileList(null)
    this.$store.commit("SET_SOURCE_LANG", "")
    this.$store.commit("SET_TARGET_LANG", "")
    this.pollingInter = null;
    const mediaQuery = window.matchMedia('(min-width: 768px)');
    mediaQuery.removeEventListener('change', this.handleResize);
  },
  created() {
    this.checkSave()
    this.currentPage = Number(sessionStorage.getItem("myCurrentPage")) || 1;
    // setTimeout(() => {
    //   this.$store.commit("SET_SOURCE_LANG", sessionStorage.getItem("sourceLang") || "")
    //   this.queryInfo = JSON.parse(sessionStorage.getItem("aligmentqueryInfo") || "{}")
    //   if (this.queryInfo && Object.keys(this.queryInfo).length) {
    //     this.userLastBatchID = this.queryInfo.userLastBatchID
    //     this.groupId = this.queryInfo.groupId
    //     this.queryPage(this.currentPage, this.groupId, this.currentRow)
    //   }
    // }, 0)
    // this.queryPage(this.currentPage, this.groupId, this.currentRow);

    const mediaQuery = window.matchMedia('(min-width: 768px)');
    mediaQuery.addEventListener('change', this.handleResize);
    this.handleResize(mediaQuery);
  },
  mounted() {
    window.addEventListener("keydown", this.shortcutKey, false);

  },
  methods: {
    ...mapMutations([
      'SET_IS_SENT',     // 设置是否对齐
    ]),
    ...mapActions([
      'changeFileNumber', // 改变单文档/双文档
      'saveFileList',     // 保存文件
      'GetUserInfo'
    ]),
    ...mapActions('alignRecords', [
      'downloadFile',              // 下载文件
      'updateDownloadLoading',     // 更新下载loading状态值
    ]),
    //上次未保存“否”
    async handleClose(){
     const {success} = await bilingualAlignmentAjax.updateBatchSendMemoryStatus({groupId:this.groupId})
     if(success){
       this.unSaveDialogVisible = false
     }
    },
    //上次未保存“是”
   async handleConfirm(){
      const myFileList = this.lastBatchInfo.myFileList
      this.$store.dispatch("changeFileNumber", myFileList.length)
      this.saveFileList(myFileList)
      this.$store.commit("SET_SOURCE_LANG", this.lastBatchInfo.sourceLang)
      this.$store.commit("SET_TARGET_LANG", this.lastBatchInfo.targetLang)
      await this.queryPage(this.currentPage, this.groupId, this.currentRow)
      this.unSaveDialogVisible = false
    },
    async checkSave(){
        const {result,success} = await bilingualAlignmentAjax.getUserLastBatch()
        if(success){
          console.log(result);
          this.lastBatchInfo = result
          this.groupId = result.groupId
          this.userLastBatchID=result.id
          if(result.isMemory==0){
            this.unSaveDialogVisible = true
          }
        }
    },
    handleResize(mediaQuery) {
      if (mediaQuery.matches) {
        console.log('Larger than 768px')
        document.documentElement.style.zoom = 1
      } else {
        console.log('Smaller than 768px')
        document.documentElement.style.zoom = 0.7
      }
    },
    //跳转对其记录
    handleralignRecords() {
      this.$router.push({ name: "alignRecords" })
    },
    //设置源语言
    setSourceLang(data) {
      this.sourceLeft = data
      this.getLangeObjectLeft(data)
    },
    //设置目标语言
    setTargetLang(data) {
      this.sourceRight = data
      this.getLangeObjectRight(data)
    },
    //设置单元格样式
    setCellStyle({ row, column, rowIndex, columnIndex }) {
      if (!row.targetSent && columnIndex === 3) {
        return "background: #F7F8FA;"
      }
    },
    // 开始双语对齐
    async beginAlignment() {
      let self = this;
      if (!this.userInfo) {
        this.$message.warning('请先登录')
        return;
      }
      self.fileArr = self.$store.state.alignment.fileList;
      if (!this.fileArr) {
        this.$message.warning('请上传文件')
        return;
      }
      // 禁止重复点击
      if (this.prohibitClick) {
        return
      }
      if (!self.sourceLang) {
        this.$message.warning('请选择源语言和目标语言')
        return;
      }
      if (!self.targetLang) {
        this.$message.warning('请选择目标语言')
        return;
      }
      if (self.sourceLang === self.targetLang) {
        this.$message.warning('源语言与目标语言不可一致')
        return;
      }
      let ary = [];
      let nameLen = true;
      let myRadio = sessionStorage.getItem("myRadio") || "2"
      
      if (myRadio === "1") {
        self.fileArr = self.fileArr.filter(item => {
          return item.uploadType === "source"
        })
      }
      if (self.fileArr.length) {
        self.fileArr.forEach(item => {
          var re = /([^\.\/\\]+)\.([a-z]+)$/i, // 匹配拿到后缀
            resultArr = re.exec(item.name);
          var type = resultArr[2];
          if (resultArr[1].length > 80) {
            nameLen = false;
            return;
          }
          if (this.fileNumber == 1) {
            ary.push({
              fileName: item.name,
              filePath: item.path,
              fileSuffix: type,
              fileSize: item.size,
            });
          } else if (this.fileNumber == 2) {
            ary.push({
              fileName: item.name,
              filePath: item.path,
              fileSuffix: type,
              fileSize: item.size,
              langCode: item.uploadType == "source" ?  self.sourceLang : self.targetLang
            });
          }
        });
        if (!nameLen) {
          this.$message.warning('文件名不得超过80个字符')
          return;
        }
        let flag = true;
        self.fileArr.forEach(item => {
          if (!item.path) {
            flag = false
            this.$message.warning('文件未上传完毕')
          }
        })
        if (!flag) return
        // this.isInitAlign = false
        let batchName = self.fileArr[0].name.split(".")[0]
        let params = {
          alignType: this.fileNumber,  //1单语文档对齐 2双语文档
          batchName,
          sourceLang: self.sourceLang,
          targetLang: self.targetLang,
          transFileList: ary
        }
        this.alignmentLoading = true // loading
        this.loadingText = `拼命加载中0%`
        this.prohibitClick = true // 禁止重复点击
        const res = await bilingualAlignmentAjax.save(params)
        this.prohibitClick = false
        if (res.resultCode === "1") {
          this.groupId = res.result.groupId
          // 掉轮询接口查看对齐状态
          this.loadingText = `拼命加载中${res.result.percent}%`
          await self.pollingAlignment()
        } else {
          this.alignmentLoading = false;
        }
      } else {
        this.alignmentLoading = false
        this.$message.warning('请先上传文件')
      }
    },
    //   //监测状态---双语对齐状态
    async pollingAlignment() {
      this.alignmentLoading = true
      let params = {
        id: this.groupId
      }
      const res = await bilingualAlignmentAjax.getUserLastBatch(params)
      if (res.success) {
        if (res.result.id === null) {
          this.alignmentLoading = false
        } else {
          // 盘对双语对齐进度是否完成
          this.loadingText = `拼命加载中${res.result.percent}%`
          if (res.result.percent !== 100 || res.result.dealStatus !== 2) {
            this.pollingInter = window.setTimeout(this.pollingAlignment, 2500);
          } else {
            // pollingNum = 0 代表第一次轮询，
            this.userLastBatchID = res.result.id
            this.groupId = res.result.groupId
            let queryBatchObj = {
              userLastBatchID: this.userLastBatchID,
              groupId: this.groupId
            }
            sessionStorage.setItem("aligmentqueryInfo", JSON.stringify(queryBatchObj))
            sessionStorage.setItem("myCurrentPage", "1")
            this.currentPage = 1
            // this.batchName = res.result.batchName
            if (this.pollingNum !== 0) {
              this.alignmentLoading = false
              this.queryPage(this.currentPage, this.groupId, this.currentRow)
              clearTimeout(this.pollingInter);
            } else {
              this.alignmentLoading = false
              clearTimeout(this.pollingInter);
            }
          }
          this.pollingNum++
        }
      } else {
        this.alignmentLoading = false
      }
    },
    //   //获取语言列表
    getLangList(type, params) {
      let obj = {
        type: type,
        [type === 1 ? "targetLang" : "sourceLang"]: params || ""
      };
      for (let propName in obj) {
        if (obj[propName] === "") {
          delete obj[propName];
        }
      }
      bilingualAlignmentAjax.queryLangList(obj).then((response) => {
        if (!response.success) {
          return;
        }
        if (type === 1) {
          this.LangList = response.result;
        } else {
          this.LangList2 = response.result;
          this.$store.commit("SET_TARGET_LANG", sessionStorage.getItem("targetLang") || "")
        }
      });
      return true
    },
    //   //选择源语言值后转换为对象 --- 源语言
    getLangeObjectLeft(value) {
      this.LangList.forEach(item => {
        if (item.sourceLang === value) {
          this.getSourceLeft(item)
        }
      });
    },
    //选择源语言值后转换为对象 --- 目标语言
    getLangeObjectRight(value) {
      this.LangList2.forEach(item => {
        if (item.targetLang === value) {
          this.getSourceRight(item)
        }
      });
    },
    // 选择语言对 左
    getSourceLeft(item) {
      this.sourceLeft = item.sourceLangName;
      this.sourceLang = item.sourceLang;
      //  修改源语言
      this.$store.commit("SET_SOURCE_LANG", item.sourceLang)
      this.getLangList(2, item.sourceLang); // 获取语言对  目标语言
    },
    // 选择语言对 右
    getSourceRight(item) {
      this.sourceRight = item.targetLangName;
      this.targetLang = item.targetLang;
      //  修改目标预言
      this.$store.commit("SET_TARGET_LANG", item.targetLang)
    },
    // 切换语言
    switchover() {
      let sourceLeft = this.sourceLeft;
      let sourceLang = this.sourceLang;
      let targetLang = this.targetLang;
      let sourceRight = this.sourceRight;
      if (!sourceLeft && !sourceLang && !targetLang && !sourceRight) {
        return
      }
      this.sourceLang = targetLang
      this.targetLang = sourceLang
      this.sourceLeft = sourceRight;
      this.sourceRight = sourceLeft;
      this.getLangList(2, this.sourceLang); // 获取语言对  目标语言
    },
    //   //选择语言结束
    toAddMemory() {
      this.saveMemoryType = 0
      this.isAddMemoryShow = true
      // this.$nextTick(() => {
      //   this.$refs.addmemory.getDomainList()
      // })
    },
    //   //取消保存数据库 - 继续对齐
    cancelAddMemory(type) {
      this.isAddMemoryShow = false
      if(type){
        this.saveFileList(null)
      }
    },
    //   //查找替换
    onSeekTxt(txt) {
      this.seekTxt = txt
    },
    onSeekTxt2(txt) {
      this.seekTxt2 = txt
    },
    //查找替换弹窗
    seekShow() {
      //  this.seekChange()
      let self = this;
      // self.codeRigBox();
      if (self.isSeekBox === 1) {
        self.isSeekBox = false;
        let dom = document.getElementById("multipleTable");
        let seekActive = dom.getElementsByClassName("seekActive");
        if (!seekActive) {
          return
        }
        let len = seekActive.length;
        if (len > 0) {
          for (let i = len - 1; i > -1; i--) {
            if (i >= 0) {
              seekActive[i].style.background = "";
              seekActive[i].classList.remove("seekActive");
            }
          }
        }
        self.seekTxt = "";
        self.seekTxt2 = "";
      } else {
        self.isSeekBox = 1;
        self.seekChange();
      }
    },
    //   // 查找
    seekChange() {
      let domList = document.getElementsByClassName("seekActive");
      let len = domList.length;
      if (len > 0) {
        for (let i = len - 1; i > -1; i--) {
          if (i >= 0) {
            domList[i].style.background = "";
            domList[i].classList.remove("seekActive");
          }
        }
      }
      this.seekNum2 = 0;
      this.seekNum = 0;
      this.seekIndex = 0;
      if (this.seekTxt === "") {
        return;
      }
      let oAt = document.getElementById('multipleTable');
      let dom = oAt.getElementsByClassName("edit");
      let seekTxt = this.seekTxt;
      if (seekTxt.indexOf(".") !== -1 || seekTxt.indexOf("?") !== -1) {
        let ary = seekTxt.split("")
        for (let i = 0; i < ary.length; i++) {
          if (ary[i] === "." || ary[i] === "?") {
            ary[i] = "\\" + ary[i]
          }
        }
        seekTxt = ary.join("")
      }
      let reg = new RegExp(seekTxt, "ig");
      dom = Array.from(dom);
      dom.forEach(item => {
        let result = reg.exec(item.innerText);
        if (result) {
          let activeStr = item.innerText.replace(reg, function (params) {
            return (
              '<span class="seekActive" style="background:yellow;">' +
              params +
              "</span>"
            );
          });
          item.innerHTML = activeStr;
          this.$nextTick(() => {
            let domActList = document.getElementsByClassName("seekActive");
            this.seekNum2 = domActList.length;
            this.seekNum = 1;
            domActList[0].scrollIntoView();
            domActList[0].style.background = "rgb(163, 217, 241)";
          });
        }
      });
    },
    //撤销
    onUndo() {
      document.execCommand("Undo");
      this.updateText = ""
    },
    //重做
    onRedo() {
      document.execCommand("Redo");
      this.updateText = ""
    },
    // 查找 上一个
    findPrevious() {
      let domList = document.getElementsByClassName("seekActive");
      let len = domList.length;
      if (len === 0 || len === 1) {
        return;
      }
      if (this.seekIndex === 0) {
        domList[len - 1].style.background = "rgb(163, 217, 241)";
        domList[0].style.background = "yellow";
        this.seekIndex = len - 1;
        domList[this.seekIndex].scrollIntoView();
        this.seekNum = len;
        return;
      }
      this.seekIndex--;
      this.seekNum--;
      domList[this.seekIndex].scrollIntoView();
      domList[this.seekIndex].style.background = "rgb(163, 217, 241)";
      domList[this.seekIndex + 1].style.background = "yellow";
    },
    // 查找 下一个
    findNext() {
      let domList = document.getElementsByClassName("seekActive");
      if (domList.length === 0 || domList.length === 1) {
        return;
      }
      if (this.seekIndex >= domList.length - 1) {
        domList[0].style.background = "rgb(163, 217, 241)";
        domList[this.seekIndex].style.background = "yellow";
        this.seekIndex = 0;
        domList[this.seekIndex].scrollIntoView();
        this.seekNum = 1;
        return;
      }
      this.seekIndex++;
      this.seekNum++;
      // console.log(this.seekIndex);
      domList[this.seekIndex].scrollIntoView();
      // let top = this.$refs.viewBox2.scrollTop;
      // this.$refs.viewBox2.scrollTo(0, num);
      if (this.seekIndex > 0) {
        domList[this.seekIndex].style.background = "rgb(163, 217, 241)";
        domList[this.seekIndex - 1].style.background = "yellow";
      } else {
        domList[this.seekIndex].style.background = "rgb(163, 217, 241)";
      }
    },
    // 替换
    async onReplace() {
      let domList = document.getElementsByClassName("seekActive");
      if (domList.length < 1) {
        // 为空时不执行
        return;
      }
      if (this.seekTxt2 === "") {
        this.$message.warning('内容不能为空')
        return
      }
      let dom = domList[this.seekIndex].parentNode;
      let sonDom = domList[this.seekIndex];
      sonDom.style.background = "";
      sonDom.innerText = this.seekTxt2;
      sonDom.classList.remove("seekActive");
      let row;
      this.tableData.forEach((item) => {
        if (item.id === Number(dom.getAttribute("sId"))) {
          row = item
        }
      })
      let type = 0
      if (dom.getAttribute("type") === "target") {  // 目标句子
        type = 1
      }
      await this.updateSent(row, dom, type, true);

      this.$nextTick(() => {
        this.seekNum2 = domList.length;
        if (this.seekNum > this.seekNum2) {
          this.seekNum = this.seekNum2;
          this.seekIndex--;
          domList[this.seekIndex].style.background = "rgb(163, 217, 241)";
        } else {
          this.seekIndex ? domList[this.seekIndex].style.background = "rgb(163, 217, 241)" : '';
        }
        this.seekChange();
      });
      if (this.seekNum2 === 1) {
        this.seekNum = 0;
      }
    },
    // 全部替换
    async replaceChange() {
      let self = this;
      let str2 = this.seekTxt;
      let str3 = this.seekTxt2;
      let flag = true;
      let oAt = document.getElementById('multipleTable');
      let isActiveDom = document.getElementsByClassName("seekActive");
      if (!isActiveDom || !isActiveDom.length) {
        return;
      }
      if (!str2) {
        return;
      }
      if (str3 === "") {
        this.$message.warning('内容不能为空')
        return
      }
      let dom = oAt.getElementsByClassName("edit");
      dom = Array.from(dom);
      let seekTxt = this.seekTxt;
      if (seekTxt.indexOf(".") !== -1 || seekTxt.indexOf("?") !== -1) {
        let ary = seekTxt.split("")
        for (let i = 0; i < ary.length; i++) {
          if (ary[i] === "." || ary[i] === "?") {
            ary[i] = "\\" + ary[i]
          }
        }
        seekTxt = ary.join("")
      }
      let reg = new RegExp(seekTxt, "ig");
      dom.forEach(item => {
        let text = item.innerHTML;
        let result = reg.exec(item.innerText);
        if (result) {
          if (str3 === "" && item.innerText === "") {
            // 阻止修改为空
            return;
          }
          let activeStr = item.innerText.replace(reg, function () {
            return (
              '<span class="seekActive" style="background:yellow;">' +
              str3 +
              "</span>"
            );
          });
          self.seekIndex = 0;
          item.innerHTML = activeStr;
          if (item.innerText === "") {
            item.innerHTML = text;
            this.$message.warning('内容不能为空')
            flag = false;
          }
        }
      });
      if (!flag) {
        return
      }
      await this.$nextTick(async () => {
        let updateSentArr = []
        let seekDom = document.getElementsByClassName("seekActive");
        seekDom = Array.from(seekDom)
        for (let i = 0; i < seekDom.length; i++) {
          console.log(seekDom[i])
          if (seekDom[i].parentNode.isContentEditable) {
            let row = this.tableData.filter(item => item.id === Number(seekDom[i].parentNode.getAttribute("sId")))
            let type = 0
            if (seekDom[i].parentNode.getAttribute("type") === "target") {  // 目标句子
              type = 1
            }
            let sent = this.getUpdateSentList(row[0], seekDom[i].parentNode, type, true)
            updateSentArr.push(sent)
            // this.updateSent(row[0], seekDom[i].parentNode, type, true);
          }
        }

        updateSentArr = updateSentArr.filter(item => {
          return item
        })
        updateSentArr = this.formatSentArr(updateSentArr)
        let params = {
          sentList: updateSentArr
        }
        const { resultCode } = await bilingualAlignmentAjax.batchUpdateBilingualSent(params)
        if (resultCode === "1") {
          this.$message.success('修改成功!')
          self.seekChange();
        }
      });
    },
    formatSentArr(arr) {
      let tempArr = [], newArr = []
      for (let i = 0; i < arr.length; i++) {
        if (tempArr.indexOf(arr[i].id) === -1) {
          newArr.push(arr[i])
          tempArr.push(arr[i].id);
        } else {
          for (let j = 0; j < newArr.length; j++) {
            if (newArr[j].id === arr[i].id) {
              Object.assign(newArr[j], arr[i])
            }
          }
        }
      }
      return newArr
    },
    //整理全部替换数据
    getUpdateSentList(row, target, type, contrast) {
      let self = this
      setTimeout(() => {
        self.sentenceShow = false
      }, 500)
      let data = target.innerText.replace(/^(\s|\u00A0)+|(\s|\u00A0)+$/g, '')
      row.te = true
      if (!contrast && self.updateText.replace(/^(\s|\u00A0)+|(\s|\u00A0)+$/g, '') === data) {
        return
      }
      if (self.repetition && data === self.repetition.data && row.id === self.repetition.id) {
        return
      }
      this.repetition = {
        id: row.id,
        data,
      }
      let params = {
        id: row.id,
        [!type ? 'sourceSent' : 'targetSent']: data,
        batchId: self.groupId,
      }
      return params
    },
    //   // 获取表格
    queryPage(page, id, rows) {
      if (this.isSeekBox) {
        this.isSeekBox = 0;
        this.seekTxt = "";
        this.seekTxt2 = "";
      }
      page = Number(page)
      this.loading = true;
      sessionStorage.removeItem("isSent")
      this.$store.commit("SET_IS_SENT")
      let params = {
        page,
        rows,
        filter: {
          group_id: id,
        },
        sort: {
          create_time: "desc"
        }
      };
      bilingualAlignmentAjax.queryPage(params).then(response => {
        if (!response.success) {
          this.loading = false
          return;
        }
        if (response.list == null) {
          response.list = [];
        }
        this.totalRows = response.totalRows;
        this.tableData = response.list;
        this.loading = false;
        if (this.currentPage > 1 && this.tableData.length < 1) {
          sessionStorage.myCurrentPage = sessionStorage.myCurrentPage - 1;
          this.currentPage -= 1;
          this.queryPage(sessionStorage.myCurrentPage, this.groupId, this.currentRow);
        } else {
          sessionStorage.setItem("isSent", "1")
          this.$store.commit("SET_IS_SENT")
          this.$nextTick(() => {
            // this.setSort()
            // console.log(this.$refs.multipleTable);
            // this.$refs.multipleTable.updateRowClassName();
          })
        }
      })
    },
    //   /**
    //    * @desc 分页操作
    //    * @param {Object} data {page,limit}
    //    */
    handlePagination({ page, limit }) {
      this.loading = true;
      document.getElementsByClassName('row-0')[0].scrollIntoView()
      this.queryPage(this.currentPage, this.groupId, this.currentRow);
      // 将页码及每页条数存sessionStorage，刷新还在当前页
      sessionStorage.setItem("myCurrentPage", JSON.stringify(page));
      sessionStorage.setItem("myCurrentRows", JSON.stringify(limit))
    },
    //   // 拖动表格
    setSort() {
      const el = this.$refs.multipleTable.$el.querySelectorAll('.el-table__body-wrapper > table > tbody')[0];
      if (document.body.style.zoom === "0.8") {  // 拖动和zoom有冲突
        el.style.zoom = "1.25"
      }
      this.sortable = Sortable.create(el, {
        ghostClass: 'sortable-ghost',
        setData: function (dataTransfer) {
          dataTransfer.setData('Text', '')
        },
        onEnd: evt => {
          const targetRow = this.tableData.splice(evt.oldIndex, 1)[0]
          this.tableData.splice(evt.newIndex, 0, targetRow)
          if (evt.newIndex !== evt.oldIndex) {
            let i = evt.newIndex;
            // if (evt.newIndex >= evt.oldIndex) {
            //   i++
            // }
            this.querySort(targetRow, i)
          }
        }
      })
    },
    // 排序接口
    async querySort(row, sort) {
      const params = {
        id: row.id,
        sort
      }
      const { resultCode } = await bilingualAlignmentAjax.moveBilingualSent(params)
      if (resultCode === '1') {
        this.$message.success('排序成功')
        this.queryPage(this.currentPage, this.groupId, this.currentRow);
      }
    },
    // 保存到记忆库
    async memoryApi(form) {
      if (this.saveMemoryType === 1) {
        await this.$router.push({ name: 'memoryLib' })
        this.saveFileList(null)
        return
      }
      let params = {
        groupId: this.groupId,
        ...form,
      }
      const resp = await bilingualAlignmentAjax.addBatchSendMemory(params)
      if (resp.success) {
        //memoryBank
        this.saveMemoryType = 1
      }
    },
    // 全部删除
    async deleteAllSent() {
      let self = this
      const resp = await bilingualAlignmentAjax.batchDeleteAll({ id: self.groupId })
      if (resp.success) {
        sessionStorage.removeItem("myFileList")
        sessionStorage.removeItem("targetLang")
        sessionStorage.removeItem("sourceLang")
        sessionStorage.removeItem("isSent")
        sessionStorage.removeItem("aligmentqueryInfo")
        self.isShow = false
        self.$store.commit("SAVE_FILE_LIST", null)
        self.$message.success('已删除全部条目')
      }
    },
    keyUp(event) {
      //确定
      if (event.keyCode === 13) {
        this.popupConfirm(data)
      } else if (event.keyCode === 27) {
        this.popupCancel(data)
      }
      // this.$parent.del();
    },
    //   // 弹窗确定
    popupConfirm(data) {
      let self = this;
      self.topText = data.topText
      self.botText = data.botText
      if (!self.isDel) {
        self.topText = self.topText.replace(/^(\s|\u00A0)+|(\s|\u00A0)+$/g, "");
        self.botText = self.botText.replace(/^(\s|\u00A0)+|(\s|\u00A0)+$/g, "");
        if (self.topText === "") {
          this.$message.warning('请填写原文')
          return;
        }
        if (self.botText === "") {
          this.$message.warning('请填写译文')
          return
        }

        let params = {
          sourceSent: self.topText,
          targetSent: self.botText,
          batchId: self.userLastBatchID,
        };
        bilingualAlignmentAjax.addBilingualSent(params).then(response => {
          if (!response.success) {
            return
          }
          self.isShow = false;
          self.topText = "";
          self.botText = "";
          sessionStorage.setItem("myCurrentPage", "1");
          self.currentPage = 1;
          self.queryPage(1, self.groupId, this.currentRow);
        })
      } else {
        if (this.deleteType === 1) {
          self.removeSelection() //删除
        } else {
          this.deleteAllSent() //删除全部
          sessionStorage.removeItem("isSent");
          this.$store.dispatch('removesetisSent', "")
        }
      }
    },
    // 弹窗取消
    popupCancel(data) {
      let self = this
      self.isShow = false
      self.topText = data.topText
      self.botText = data.botText
    },
    // 添加弹窗
    addPopupShow() {
      let self = this
      self.isShow = true
      self.isDel = false
      self.downloadBoxTit = '添加句对'
    },
    // 添加弹窗关闭
    closePopup() {
      this.isShow = false
    },
    // 删除弹窗
    toggleBox(type) {
      let self = this
      if (this.multipleSelection.length < 1 && type === 'check') {
        this.$message.warning('请选择要删除的数据')
        return
      }
      self.downloadBoxTit = '删除提示'
      if (type === 'all') {
        self.downloadBoxText = '确认删除所有的双语对齐条目？'
        self.deleteType = 2
      } else {
        self.downloadBoxText = "确认删除选中的双语对齐条目？"
        self.deleteType = 1
      }
      self.isShow = true
      self.isDel = true
    },
    //  删除
    removeSelection() {
      let self = this
      let params = {
        id: this.userLastBatchID,
        idList: this.multipleSelection,
      }
      bilingualAlignmentAjax.batchDeleteByIdList(params).then((response) => {
        if (!response.success) {
          return
        }
        self.isShow = false;
        self.sentCount = self.sentCount - self.multipleSelection.length;
        self.queryPage(self.currentPage, self.groupId, self.currentRow);
      })
    },
    //调换
    async exchangeSent() {
      const params = {
        id: this.groupId,
      }
      const { resultCode } = await bilingualAlignmentAjax.exchangeSourceTarget(params)
      if (resultCode === '1') {
        this.currentPage = 1;
        this.queryPage(this.currentPage, this.groupId, this.currentRow);
        this.$message.success('调换成功')
      }
    },
    //去重
    async deleteRepeatSent() {
      const params = {
        id: this.groupId,
      }
      const { resultCode } = await bilingualAlignmentAjax.deleteRepeatSent(params)
      if (resultCode === '1') {
        this.currentPage = 1;
        this.queryPage(this.currentPage, this.groupId, this.currentRow);
        this.$message.success('去重成功')
      }
    },
    // 合并
    async onMerge() {
      console.log(this.multipleSelection);
      if (this.multipleSelection.length < 2) {
        this.$message.warning('请选择要合并的数据')
        return
      }
      if (this.upMerge) {
        this.$message.warning('合并的数据要连续')
        return
      }

      const params = {
        idFrom: this.multipleSelection.slice(1), // 被合并句子ID集合
        idTo: this.multipleSelection[0], // 合并到句子ID
      }
      const { resultCode } = await bilingualAlignmentAjax.mergeBilingualSent(params)
      if (resultCode === '1') {
        this.$message.success('合并成功')
        this.queryPage(this.currentPage, this.groupId, this.currentRow);
      }
    },
    // 拆分
    async onSplit() {
      if (!this.sentenceShow) {
        this.$message.warning('请将光标放在编辑区')
        return
      }

      if (!this.splitTargetSent) {
        this.$message.warning('请将光标放在编辑区')
        return
      }
      const params = {
        type: this.cellType,
        id: this.row.id,
        spiltIndex: this.splitSourceSent.length,
      }
      const { resultCode } = await bilingualAlignmentAjax.spiltBilingualSent(params)
      if (resultCode === '1') {
        this.$message.success('拆分成功')
        this.queryPage(this.currentPage, this.groupId, this.currentRow);
      }
    },
    //可编辑获取坐标
    getDivPosition(element) {
      let caretOffset = 0
      let doc = element.ownerDocument || element.document
      let win = doc.defaultView || doc.parentWindow
      let sel
      if (typeof win.getSelection !== 'undefined') {
        //谷歌、火狐
        sel = win.getSelection()
        if (sel.rangeCount > 0) {
          //选中的区域
          let range = win.getSelection().getRangeAt(0)
          let preCaretRange = range.cloneRange() //克隆一个选中区域
          preCaretRange.selectNodeContents(element) //设置选中区域的节点内容为当前节点
          preCaretRange.setEnd(range.endContainer, range.endOffset) //重置选中区域的结束位置
          caretOffset = preCaretRange.toString().length
        }
      } else if ((sel = doc.selection) && sel.type !== 'Control') {
        //IE
        let textRange = sel.createRange()
        let preCaretTextRange = doc.body.createTextRange()
        preCaretTextRange.moveToElementText(element)
        preCaretTextRange.setEndPoint('EndToEnd', textRange)
        caretOffset = preCaretTextRange.text.length
      }
      return caretOffset
    },
    //   /**
    //    * @desc 下载原文1 译文2 原译对照3 TMX4
    //    * @param {Number} type 1 2 3 4
    //    */
    async handleDownload(type) {
      const params = {
        fileId: this.userLastBatchID,
        type
      }
      this.downloadFile(params)
    },
    // 快捷键
    shortcutKey(e) {
      let self = this
      if (!self.userInfo) {
        return
      }
      if (!this.isSent) return

      e = e || window.event;
      let k = e.keyCode || e.which;
      switch (k) {
        case 219:
          if (e.ctrlKey) {
            self.addPopupShow()
            e.returnValue = false
            e.preventDefault()
            return false
          }
          break
        case 71: //
          if (e.ctrlKey && e.altKey) {
            // 拆分
            e.returnValue = false
            self.onSplit()
            e.preventDefault()
            return false
          } else if (e.ctrlKey) {
            // 合并
            e.returnValue = false
            self.onMerge()
            e.preventDefault()
            return false
          }
          break
        case 77: // 添加到记忆库
          if (e.ctrlKey) {
            e.returnValue = false
            self.toAddMemory()
            e.preventDefault()
            return false
          }
          break
        case 221: // 删除
          if (e.ctrlKey) {
            self.toggleBox('check')
            e.preventDefault()
            e.returnValue = false
            return false
          }
          break
        case 46: // 全部删除
          if (e.ctrlKey) {
            self.deleteAllSent()
            e.preventDefault()
            e.returnValue = false
            return false
          }
          break
        case 70:
          if (e.ctrlKey) {
            // 查找替换
            e.returnValue = false
            self.seekShow()
            e.preventDefault()
            return false
          }
          break
        case 73: //i
          if (e.ctrlKey) {
            // 查找替换
            e.returnValue = false
            self.exchangeSent()
            e.preventDefault()
            return false
          }
          break
        case 76:
          if (e.ctrlKey) {
            // 查找替换
            e.returnValue = false
            self.deleteRepeatSent()
            e.preventDefault()
            return false
          }
          break
      }
    },
    handleSelectionChange(val) {
      console.log('---------',val);
      // 选中的元素
      let arr = []
      if (val.length > 1) {
        val.sort((a, b) => {
          return a.sort - b.sort
        })
      }
      this.upMerge = false
      val.forEach((item, index) => {
        if (val[index + 1] && item.sort + 1 !== val[index + 1].sort) {
          this.upMerge = true
        }
        arr.push(item.id)
      })
      this.multipleSelection = arr
    },
    // //单元格处理
    // tableRowClassName({ row, rowIndex }) {
    //   // console.log(row ,rowIndex,'-----------');
    //     this.tableRowIndex = row.sectionIndex
    //     if (row.sectionIndex % 2 === 1) {
    //       if (this.tableData.filter(item => item.sectionIndex === row.sectionIndex).length === 1) {
    //         return `even-row ${'row-' + rowIndex} even-top even-bottom`
    //       }
    //       if (this.tableData.find(item => item.sectionIndex === row.sectionIndex).id === row.id) {
    //         return `even-row ${'row-' + rowIndex} even-top`
    //       } else if (this.tableData.findLast(item => item.sectionIndex === row.sectionIndex).id === row.id) {
    //         return `even-row ${'row-' + rowIndex} even-bottom`
    //       }
    //       return `even-row ${'row-' + rowIndex}`
    //     } else {
    //       if (this.tableData.filter(item => item.sectionIndex === row.sectionIndex).length === 1) {
    //         return `odd-row ${'row-' + rowIndex} odd-top odd-bottom`
    //       }
    //       if (this.tableData.find(item => item.sectionIndex === row.sectionIndex).id === row.id) {
    //         // console.log(this.tableData.filter(item => item.sectionIndex === row.sectionIndex).length)
    //         return `odd-row ${'row-' + rowIndex} odd-top`
    //       } else if (this.tableData.findLast(item => item.sectionIndex === row.sectionIndex).id === row.id) {
    //         return `odd-row ${'row-' + rowIndex} odd-bottom`
    //       }
    //       return `odd-row ${'row-' + rowIndex}`
    //     }
    // },
    tableRowClassName({ row, rowIndex }) {
      this.tableRowIndex = row.sectionIndex;
      const isEvenRow = row.sectionIndex % 2 === 1;
      const sectionRows = this.tableData.filter(item => item.sectionIndex === row.sectionIndex);
      const isFirstRow = sectionRows[0].id === row.id;
      const isLastRow = sectionRows[sectionRows.length - 1].id === row.id;

      if (isEvenRow) { //基数行
        if (sectionRows.length === 1) {
          return `even-row ${'row-' + rowIndex} even-only`;
        } else if (isFirstRow) {
          return `even-row ${'row-' + rowIndex} even-top`;
        } else if (isLastRow) {
          return `even-row ${'row-' + rowIndex} even-bottom`;
        } else {
          return `even-row ${'row-' + rowIndex}`;
        }
      } else {
        if (sectionRows.length === 1) {
          return `odd-row ${'row-' + rowIndex} odd-only`;
        } else if (isFirstRow) {
          return `odd-row ${'row-' + rowIndex} odd-top`;
        } else if (isLastRow) {
          return `odd-row ${'row-' + rowIndex} odd-bottom`;
        } else {
          return `odd-row ${'row-' + rowIndex}`;
        }
      }
    },
    //   // 验证是否修改
    changeVerify(e) {
      this.beforeDate = e.target.innerHTML
      this.updateText = e.target.innerText
    },
    //   // 获取光标位置
    getCursorPosition(e, row) {
      const event = e || window.event
      let srcCell = event.target.getAttribute("type")
      if (srcCell === "source") {
        this.cellType = 1
      } else if (srcCell === "target") {
        this.cellType = 2
      }
      this.row = row;
      this.sentenceShow = true;
      let pos = 0;
      pos = this.getDivPosition(e.target);
      this.splitSourceSent = e.target.innerText.slice(0, pos);
      this.splitTargetSent = e.target.innerText.slice(pos);
    },
    setLimitLength(event) {
      let dom = event.target;
      // dom.focus();
      if (dom.innerText.length > 2000 && event.keyCode !== 8 && event.keyCode !== 116) {
        this.$message.warning('最大可输入2000字符!')
        event.preventDefault()
      }
    },
    setMaxlength(event) {
      let ev = event || window.event
      if (ev.target.innerText.length > 2000) {
        setTimeout(() => {
          ev.target.innerText = ev.target.innerText.substring(0, 2000)
          this.$message.warning('最大可输入2000字符!')
          this.keepLastIndex(ev.target)
        }, 0)
      }
      if (ev.target.innerText.length > 2000 && ev.keyCode !== 8 && ev.keyCode !== 116) {
        this.$message.warning('最大可输入2000字符!')
        ev.preventDefault()
      }
    },
    keepLastIndex(obj) {
      if (window.getSelection) { //ie11 10 9 ff safari
        obj.focus(); //解决ff不获取焦点无法定位问题
        let range = window.getSelection(); //创建range
        range.selectAllChildren(obj); //range 选择obj下所有子内容
        range.collapseToEnd(); //光标移至最后
      } else if (document.selection) { //ie10 9 8 7 6 5
        let range = document.selection.createRange(); //创建选择对象
        //var range = document.body.createTextRange();
        range.moveToElementText(obj); //range定位到obj
        range.collapse(false); //光标移至最后
        range.select();
      }
    },
    //   // 修改
    updateSent(row, target, type, contrast) {
      let self = this
      setTimeout(() => {
        this.sentenceShow = false
      }, 500)
      let data = target.innerText.replace(/^(\s|\u00A0)+|(\s|\u00A0)+$/g, '')
      row.te = true
      if (!contrast && this.updateText.replace(/^(\s|\u00A0)+|(\s|\u00A0)+$/g, '') === data) {
        return
      }
      if (this.repetition && data === this.repetition.data && row.id === this.repetition.id) {
        return
      }
      this.repetition = {
        id: row.id,
        data,
      }
      let params = {
        id: row.id,
        [!type ? 'sourceSent' : 'targetSent']: data,
        batchId: this.groupId,
      }
      bilingualAlignmentAjax.updateBilingualSent(params).then((response) => {
        if (response.resultCode === '1') {
          this.$message.success('修改成功')
        } else {
          const e = window.event || e
          e.target.innerHTML = self.beforeDate
        }
      })
    },
    //   // 选中
    selectOn(e) {
      let event = window.event || e
      let target = event.srcElement ? event.srcElement : event.target
      if (/input|textarea/i.test(target.tagName) && /firefox/i.test(navigator.userAgent)) {
        //Firefox在文本框内选择文字
        let staIndex = target.selectionStart
        let endIndex = target.selectionEnd
        if (staIndex !== endIndex) {
          let sText = target.value.substring(staIndex, endIndex)
          this.selectText(sText)
        }
      } else {
        //获取选中文字
        let sText = document.selection === undefined ? document.getSelection().toString() : document.selection.createRange().text
        if (sText !== '') {
          //将参数传入回调函数fn
          this.selectText(sText)
        }
      }
    },
    //   // 选中文字
    selectText(txt) {
      this.seekTxt = txt
      if (this.isSeekBox === 1) {
        // this.seekChange()
      }
    },
  },
}
</script>

<style lang="less" scoped>
@import "./style/index.less";
</style>
<style lang="less">
.editor-tool {
  width: 423px;
}
</style>
